import React, { Fragment, useState, useEffect } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
    },
    {
        id: 2,
        title: 'About',
        link: '/about',
    },
    {
        id: 3,
        title: 'Services',
        link: '/services',
         submenu: [
            { id: 71, title: 'Web App Development', link: '/services/web-app-development' },
            { id: 72, title: 'Mobile App Development', link: '/services/mobile-app-development' },
            { id: 73, title: 'UI/UX Design', link: '/services/ui-ux' },
            { id: 74, title: 'Cloud Infrastructure', link: '/services/cloud-infrastructure' },
            { id: 75, title: 'IT Staffing', link: '/services/it-staffing' },
            { id: 76, title: 'Offshore Development', link: '/services/offshore-development' },
        ]
    },
    {
        id: 4,
        title: 'Products',
        link: '/products',
         submenu: [
            { id: 71, title: 'ERP System', link: '/products/erp' },
            { id: 72, title: 'CRM Platform', link: '/products/crm' },
        ]
    },
    {
        id: 5,
        title: 'Careers',
        link: '/career',
    },
    {
        id: 6,
        title: 'Contact',
        link: '/contact',
    }
];

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false);
        setOpenId(0);
    };

    // ✅ Prevent body scroll when menu is active
    useEffect(() => {
        if (menuActive) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto"; // cleanup
        };
    }, [menuActive]);

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}>
                        <i className="ti-close"></i>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ? (
                                    <Fragment>
                                        <p
                                            className="m-0"
                                            onClick={() => setOpenId(item.id === openId ? 0 : item.id)}
                                        >
                                            {item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                {item.submenu.map((submenu, i) => (
                                                    <ListItem key={i}>
                                                        <NavLink
                                                            onClick={ClickHandler}
                                                            className="active"
                                                            to={submenu.link}
                                                        >
                                                            {submenu.title}
                                                        </NavLink>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                ) : (
                                    <NavLink
                                        className="active"
                                        to={item.link}
                                        onClick={
                                            ["/about", "/project", "/contact"].includes(item.link)
                                                ? ClickHandler
                                                : undefined
                                        }
                                    >
                                        {item.title}
                                    </NavLink>
                                )}
                            </ListItem>
                        );
                    })}
                </ul>
            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    );
};

export default MobileMenu;
